import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { LogAssignation } from "src/app/core/services/business/model/log-assignation";
import { LogAssignationService } from "src/app/core/services/business/service/log-assignation.service";

@Component({
  selector: "app-log-assignation",
  templateUrl: "./log-assignation.component.html",
  styleUrls: ["./log-assignation.component.scss"],
})
export class LogAssignationComponent implements OnInit {
  @Input() requestId;
  @Input() taskKey;

  logAssignations: LogAssignation[];

  constructor(
    public activeModal: NgbActiveModal,
    private _logAssignationService: LogAssignationService
  ) {}

  ngOnInit() {
    this.getLogAssignationByRequestAndTask(this.requestId, this.taskKey);
  }

  getLogAssignationByRequestAndTask(requestId, taskKey) {
    this._logAssignationService
      .getLogAssignationByRequestAndTask(requestId, taskKey)
      .subscribe(
        (data) => {
          this.logAssignations = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
